// const storagePolicyFormat = [
//     {
//         code: 'NECESSARY',
//         enabled: false
//     }
// ]

// const itemKeyWithVariables = 'item_key_{{id}}'

// const storageManagerPutParams = {
//     key: item_key_{{id}},
//     value: any,
//     storageLevel: StorageLevelMap = LOCAL_STORAGE,
//     expiryDays: number = 1,
//     codec: boolean = true,
//     variables: {id: 123}
// }


const storageKeyPrefix = 'h_';
const bannerExpiryDays = 30;
const bannerKey = `${storageKeyPrefix}storage-policy-banner`;
const storagePolicyKey = `${storageKeyPrefix}storage-policy`;
const notSupportedMsg = 'is not supported storage key';

const StorageItemsCategoriesCodesMap = {
    NECESSARY: 'NECESSARY',
    PREFERENCES: 'PREFERENCES',
    ANALYTICS: 'ANALYTICS',
    MARKETING: 'MARKETING',
};
const StorageItemsSourcesCodesMap = {
    HARRI: 'HARRI'
};
const StorageLevelMap = {
    COOKIES: 'COOKIES',
    LOCAL_STORAGE: 'LOCAL_STORAGE',
    SESSION: 'SESSION',
};

const HStorageItems = [
    {
        code: StorageItemsCategoriesCodesMap.NECESSARY,
        alwaysEnabled: true,
        sources: [
            {
                code: StorageItemsSourcesCodesMap.HARRI,
                items: [
                    {
                        key: 'employee_voice_locations_view_ids',
                    },
                    {
                        key: 'locations_table_sections_state_{{userId}}',
                    },
                    {
                        key: 'storage-policy',
                    },
                    {
                        key: 'storage-policy-banner',
                    },
                    {
                        key: 'csrftoken',
                    },
                    {
                        key: 'sso_login_redirect_url',
                    },
                    {
                        key: 'loginTime',
                    },
                    {
                        key: 'userContext',
                    },
                    {
                        key: 'InteractBrandsCookie',
                    },
                    {
                        key: 'mainFocusInput',
                    },
                    {
                        key: 'brand_slug',
                    },
                    {
                        key: 'brand_id',
                    },
                    {
                        key: 'brand_name',
                    },
                    {
                        key: 'tts_li_utms',
                    },
                    {
                        key: 'candidateAppMobileWelcome',
                    },
                    {
                        key: 'nopromo',
                    },
                    {
                        key: 'weekly_known_as',
                    },
                    {
                        key: 'daily_known_as',
                    },
                    {
                        key: 'hUserLocation',
                    },
                    {
                        key: 'enterprise_id',
                    },
                    {
                        key: 'enterprise_slug',
                    },
                    {
                        key: 'new_user_user_candidate',
                    },
                    {
                        key: 'toggledBrandsCookie',
                    },
                    {
                        key: 'username_referral',
                    },
                    {
                        key: 'onboarding_attachment_code_lookups',
                    },
                    {
                        key: 'secondAuthToken',
                    },
                    {
                        key: 'abs-productivity-hours',
                    },
                    {
                        key: 'carriStepByStepHideen',
                    },
                    {
                        key: 'brand_selector_list_type_{{id}}',
                    },
                    {
                        key: 'dash_filters_{{id}}',
                    },
                    {
                        key: 'brand_theme',
                    },
                    {
                        key: 'csp_theme',
                    },
                    {
                        key: 'apply_modal_theme',
                    },
                    {
                        key: 'career_portal_theme',
                    },
                    {
                        key: 'job_page_theme',
                    },
                    {
                        key: 'preview_job_page_theme',
                    },
                    {
                        key: 'brand_profile_theme',
                    },
                    {
                        key: 'healch-check-print-options',
                    },
                    {
                        key: 'qsr_api_key',
                    },
                    {
                        key: 'FlashDashCustomization',
                    },
                    {
                        key: 'review_docs_prev_state',
                    },
                    {
                        key: 'docs_search_{{key}}',
                    },
                    {
                        key: 'job_distance_{{id}}',
                    },
                    {
                        key: 'is_user',
                    },
                    {
                        key: 'employer_sign_document_controller_data',
                    },
                    {
                        key: 'search_filters_1',
                    },
                    {
                        key: 'hide_tl_requests_modal',
                    },
                    {
                        key: 'client_id',
                    },
                    {
                        key: 'full_burden_apply_bonus_{{brandId}}_{{date}}',
                    },
                    {
                        key: 'tl_schedule_preset',
                    },
                    {
                        key: 'tl_schedule_visibility{{id}}',
                    },
                    {
                        key: 'tl_schedule_view',
                    },
                    {
                        key: 'tl_schedule_weeks_count',
                    },
                    {
                        key: 'tl_sort_by',
                    },
                    {
                        key: 'tl_schedule_filters{{id}}',
                    },
                    {
                        key: 'employee_sort_type',
                    },
                    {
                        key: 'tl_printing_schedule',
                    },
                    {
                        key: 'tl_time_off_sort_by',
                    },
                    {
                        key: 'e_verify_training_visited_chapters_index',
                    },
                    {
                        key: 'selected_business_id',
                    },
                    {
                        key: 'DASHBOARDS_LOCATIONS_FILTER_DATA',
                    },
                    {
                        key: 'DLP_WIDGET_{{widgetKey}}_{{userId}}',
                    },
                    {
                        key: 'HALO_DASHBOARD_SELECTED_CATEGORIES',
                    },
                    {
                        key: 'HALO_DASHBOARD_SELECTED_POSITIONS',
                    },
                    {
                        key: 'HALO_DASHBOARD_VIEW_TYPE{{userId}}',
                    },
                    {
                        key: 'RISK_DASHBOARD_VIEW_TYPE{{userId}}',
                    },
                    {
                        key: 'RISK_DASHBOARD_COMPARISON_VIEW_TYPE{{userId}}',
                    },
                    {
                        key: 'RISK_DASHBOARD_LITE_INTEREST_REGISTERED{{userId}}',
                    },
                    {
                        key: 'core_hr_employees_view',
                    },
                    {
                        key: 'touchpoints_layout',
                    },
                    {
                        key: 'shift_trade_sort_by',
                    },
                    {
                        key: 'show_request_matching_skills_only',
                    },
                    {
                        key: 'warnings',
                    },
                    {
                        key: 'user_location',
                    },
                    {
                        key: 'Recite.Persist',
                    },
                    {
                        key: 'placeholder_token',
                    },
                    {
                        key: 'dashboards__location_ids',
                    },
                    {
                        key: 'dashboards__categories_positions',
                    },
                    {
                        key: '{{area}}',
                    },
                    {
                        key: 'isQSRLogin',
                    },
                    {
                        key: 'previewJobPayload',
                    },
                    {
                        key: 'jobsFilters{{userId}}',
                    },
                    {
                        key: 'applicantsFilters{{userId}}',
                    },
                    {
                        key: 'interviewFilters{{userId}}',
                    },
                    {
                        key: 'INCLUDE_EVERGREEN_AND_BOOSTED{{userId}}',
                    },
                    {
                        key: 'customWelcomePageShown',
                    },
                    {
                        key: 'shared_state',
                    },
                    {
                        key: 'comms_newsfeed_collapse_expand',
                    },
                    {
                        key: 'magicLinkToken',
                    },
                    {
                        key: 'emailToken',
                    },
                    {
                        key: 'punch-show-breaks-switch-value'
                    },
                    {
                        key: 'career_portal_redirection{{job}}',
                    },
                    {
                        key: 'client_id',
                    }
                ]
            }
        ]
    },
    {
        code: StorageItemsCategoriesCodesMap.PREFERENCES,
        sources: [
            {
                code: StorageItemsSourcesCodesMap.HARRI,
                items: [
                    {
                        key: 'hmap_active_ui_view',
                    },
                    {
                        key: 'hmap_active_view',
                    },
                    {
                        key: 'hmap_active_sorting',
                    },
                    {
                        key: 'send_on_enter',
                    },
                    {
                        key: 'selectedJobFilterDashboard',
                    },
                    {
                        key: 'lang',
                    },
                    {
                        key: 'previous_search',
                    },
                    {
                        key: 'mobile-banner-closed',
                    },
                    {
                        key: 'ONBOARDING_VIEW',
                    },
                    {
                        key: 'hideIEWarningModal',
                    },
                    {
                        key: 'dontShowRemoveJobWarning',
                    },
                    {
                        key: 'isWarningConfirmed',
                    },
                    {
                        key: '@GP-REPORTS',
                    },
                    {
                        key: 'dashboards__previousSelectedFilters__{{userId}}',
                    },
                    {
                        key: 'side_bar_state_{{id}}',
                    },
                    {
                      key: `permissions_users_sort_{{viewId}}`
                    },
                    {
                        key: 'punch_show_breaks',
                    },
                    {
                        key: 'core_hr_employees_view',
                    },
                    {
                        key: 'touchpoints_layout',
                    },
                    {
                        key: 'walk-through-dashs',
                    },
                    {
                        key: 'walk-through-tts',
                    },
                    {
                        key: 'walk-through-barri',
                    },
                    {
                        key: 'uploadEmployeesFilters{{userId}}',
                    },
                ]
            }
        ]
    },
    {
        code: StorageItemsCategoriesCodesMap.ANALYTICS,
        sources: []
    },
    {
        code: StorageItemsCategoriesCodesMap.MARKETING,
        sources: []
    }
];

const getUserStoragePolicy = () => {
    return HCookiesStore.get(storagePolicyKey, true) || HLocalStorageStore.get(storagePolicyKey);
}

const HStoragePolicyManager = {
    Categories: StorageItemsCategoriesCodesMap,
    allowAll() {
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: true
            });
        });

        HCookiesStore.put(storagePolicyKey, categories, undefined, true);
        HCookiesStore.put(bannerKey, true, bannerExpiryDays, true);

        if (window.HThirdPartyManager) {
            window.HThirdPartyManager.onCookiesPolicyChanged();
        }
    },
    deny() {
        const previousCategories = getUserStoragePolicy() || [];
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: !!cat.alwaysEnabled
            });
        });

        // Check if any previously enabled category is now disabled
        const needsReload = previousCategories.some(prevCat => {
            if (!prevCat.enabled) return false; // Skip if it was already disabled
            const willBeDisabled = !categories.find(c => c.code === prevCat.code)?.enabled;
            return willBeDisabled;
        });

        HCookiesStore.put(storagePolicyKey, categories, undefined, true);
        HCookiesStore.put(bannerKey, true, bannerExpiryDays, true);

        if (needsReload) {
            window.location.reload();
        } else if (window.HThirdPartyManager) {
            window.HThirdPartyManager.onCookiesPolicyChanged();
        }
    },
    allowSelection(allowedCategories) {
        const previousCategories = getUserStoragePolicy() || [];
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: cat.alwaysEnabled || allowedCategories.indexOf(cat.code) > -1
            });
        });

        // Check if any previously enabled category is now disabled
        const needsReload = previousCategories.some(prevCat => {
            if (!prevCat.enabled) return false; // Skip if it was already disabled
            const willBeDisabled = !categories.find(c => c.code === prevCat.code)?.enabled;
            return willBeDisabled;
        });

        HCookiesStore.put(storagePolicyKey, categories, undefined, true);
        HCookiesStore.put(bannerKey, true, bannerExpiryDays, true);

        if (needsReload) {
            window.location.reload();
        } else if (window.HThirdPartyManager) {
            window.HThirdPartyManager.onCookiesPolicyChanged();
        }
    },
    isCategoryEnabled(code) {
        const categories = getUserStoragePolicy();
        return HStorageItems.find(c => c.code === code)?.alwaysEnabled || categories?.find(cat => cat.code === code)?.enabled;
    },
    isPolicyChecked() {
        const isChecked = HCookiesStore.get(bannerKey, true);
        return !!isChecked;
    },
    isItemAllowed(options) {
        const categories = getUserStoragePolicy();
        for (let cat of HStorageItems) {
            for (let src of cat.sources) {
                for (let item of src.items) {
                    if (item.key === options.key) {
                        return cat.alwaysEnabled || categories?.find(c => c.code === cat.code)?.enabled;
                    }
                }
            }
        }
        return false;
    },
    isItemSupported(options) {
        for (let cat of HStorageItems) {
            for (let src of cat.sources) {
                for (let item of src.items) {
                    if (item.key === options.key) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
    _notifyCategoryChange() {
        if (window.HThirdPartyManager) {
            window.HThirdPartyManager.onCookiesPolicyChanged();
        }
    }
};

function getStorageKeyForItem(itemName, variables) {
    if (variables) {
        for (let key in variables) {
            itemName = itemName.split(`{{${key}}}`).join(variables[key])
        }
    }
    return storageKeyPrefix + itemName;
}

function getDefaultOptions(key, variables, storageLevel) {
    const options = {
        codec: true,
        storageKey: getStorageKeyForItem(key, variables)
    }
    switch (storageLevel) {
        case StorageLevelMap.COOKIES:
            options.expiryDays = 30;
            break;
    }
    return options;
}

function isSessionStorageSupported() {
    try {
        const storage = window?.sessionStorage;
        storage.setItem('test', 'test');
        storage.removeItem('test');
        return true;
    } catch (e) {
        console.warn("Browser doesn't support session storage");
        return false;
    }
}

const HStorageManager = {
    StorageLevels: StorageLevelMap,
    get(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables, _options.storageLevel),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        return HCookiesStore.get(options.storageKey, options.codec);
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            return HSessionStore.get(options.storageKey);
                        }
                        else {
                            return HMemoryStore.get(options.storageKey);
                        }
                    default:
                        return HLocalStorageStore.get(options.storageKey);
                }
            } else {
                return HMemoryStore.get(options.storageKey);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    },
    put(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables, _options.storageLevel),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        HCookiesStore.put(options.storageKey, options.value, options.expiryDays, options.codec);
                        break;
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            HSessionStore.put(options.storageKey, options.value);
                        }
                        else {
                            HMemoryStore.put(options.storageKey, options.value);
                        }
                        break;
                    default:
                        HLocalStorageStore.put(options.storageKey, options.value, options.expiryDays);
                }
            } else {
                HMemoryStore.put(options.storageKey, options.value);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    },
    remove(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables, _options.storageLevel),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        HCookiesStore.remove(options.storageKey);
                        break;
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            HSessionStore.remove(options.storageKey);
                        }
                        else {
                            HMemoryStore.remove(options.storageKey);
                        }
                        break;
                    default:
                        HLocalStorageStore.remove(options.storageKey);
                }
            } else {
                HMemoryStore.remove(options.storageKey);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    }
};

HLocalStorageStore?.cleanExpiredLocalStorageItems(storageKeyPrefix);

if (typeof window !== "undefined") {
    window.HStorageItems = HStorageItems;
    window.HStoragePolicyManager = HStoragePolicyManager;
    window.HStorageManager = HStorageManager;
}